let Global = {
    Blazy: function () {
        Global.BlazyInstance = new Blazy({
            breakpoints: [{
                width: 0,
                src: 'data-src-small'
            }, {
                width: 640,
                src: 'data-src-medium'
            }, {
                width: 1024,
                src: 'data-src-large'
            }, {
                width: 1200,
                src: 'data-src-xlarge'
            }, {
                width: 1440,
                src: 'data-src-xxlarge'
            }]
        })
    },

    Mobile: function () {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    },

    Barba: function () {
        let FadeTransition = Barba.BaseTransition.extend({
            start: function () {
                // As soon the loading is finished and the old page is faded out, let's fade the new page
                Promise
                    .all([this.newContainerLoading, this.fadeOut()])
                    .then(this.fadeIn.bind(this));
            },

            fadeOut: function () {
                return new Promise((resolve, reject) => {
                    document.querySelector('.barba-bg').className += ' barba-bg--visible';
                    window.setTimeout(function () {
                        resolve();
                    }, 500);
                });
            },

            fadeIn: function () {
                let _this = this;
                (this.oldContainer).style.display = 'none';

                window.scrollTo(0, 0);

                document.querySelector('.barba-bg').classList.remove('barba-bg--visible');
                _this.done();
                }
        });

        Barba.Pjax.getTransition = function () {
            return FadeTransition;
        };
    },
    Vvalidate: function() {
        Vue.use(VeeValidate, {
            locale: 'nl',
            events: 'blur|submit',
            classes: true,
            invalidateFalse: true,
            classNames: {
                invalid: 'input--invalid',
                valid: 'input--valid'
            },
            dictionary: {
                nl: { messages: Global.FormDictionary}
            }
        });
    },
    SubmitForm: function (form, gtmEvent) {
        form.classList.toggle('form--loading');

        if(form.querySelector('.form-message')) {
            form.querySelector('.form-message').remove();
        }

        let messageTemplate =
            '<div class="form-message form-message--active %status%">' +
            '   <div class="form-message__content">%message%</div>' +
            '   <span class="form-message__icon form-message__icon--success">' +
            '       <svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"/></svg>' +
            '   </span>' +
            '   <span class="form-message__icon form-message__icon--error">' +
            '       <svg width="32" height="32" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1088 1248v224q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-224q0-26 19-45t45-19h256q26 0 45 19t19 45zm30-1056l-28 768q-1 26-20.5 45t-45.5 19h-256q-26 0-45.5-19t-20.5-45l-28-768q-1-26 17.5-45t44.5-19h320q26 0 44.5 19t17.5 45z"/></svg>' +
            '   </span>' +
            '</div>';

        let formData = new FormData(form);

        axios({
            method: 'post',
            url: form.action,
            data: formData
        }).then(function (response) {

            if (response.data.target) {
                Barba.Pjax.goTo(response.data.target);
                return;
            }

            messageTemplate = messageTemplate.replace(/%message%/, response.data.message);
            messageTemplate = messageTemplate.replace(/%status%/, 'form-message--success');

            form.innerHTML = messageTemplate;
            form.classList.toggle('form--loading');

            // Sends the event to the Google Analytics property with
            // tracking ID GA_TRACKING_ID set by the config command in
            // the global tracking snippet.
            if (window.gtag !== undefined) {
                gtag('event', 'Ingevuld', {
                    'event_category': (gtmEvent !== undefined ? gtmEvent : 'Formulierenbeheer')
                });
            }

            Listeners.MoveToInstance.move(document.querySelector('.form-message'));

        }).catch(function (error) {
            if (error.response !== undefined) {
                messageTemplate = messageTemplate.replace(/%message%/, error.response.data.message);
                messageTemplate = messageTemplate.replace(/%status%/, 'form-message--error');

                form.classList.toggle('form--loading');
                form.insertAdjacentHTML('afterbegin', messageTemplate);
                Listeners.MoveToInstance.move(document.querySelector('.form-message'));
            } else {
                //console.error(error);
                Listeners.MoveToInstance.move(document.querySelector('.form-message'));
            }
        });
    },
    FormDictionary: {
        _default: (field) => `This field has not been entered correctly.`,
        after: (field, [target, inclusion]) => `Dit veld moet groter ${inclusion ? 'of gelijk aan ' : ''} ${target}.`,
        alpha_dash: (field) => `Dit veld mag alleen alfanumerieke karakters, strepen en onderstrepingstekenen bevatten.`,
        alpha_num: (field) => `Dit veld mag alleen alfanumerieke karakters bevatten.`,
        alpha_spaces: (field) => `Dit veld mag alleen alfanumerieke karakters en spaties bevatten.`,
        alpha: (field) => `Dit veld mag alleen alfabetische karakters bevatten.`,
        before: (field, [target, inclusion]) => `De waarde van dit veld moet kleiner ${inclusion ? 'of gelijk aan' : ''} ${target} zijn.`,
        between: (field, [min, max]) => `De waarde van dit veld moet tussen ${min} en ${max} zijn.`,
        confirmed: (field) => `Dit bevestigingsveld komt niet overeen.`,
        credit_card: (field) => `Dit veld is ongeldig.`,
        date_between: (field, [min, max]) => `De datum moet tussen ${min} en ${max} zijn.`,
        date_format: (field, [format]) => `Dit veld moet het volgende formaat hebben: ${format}.`,
        decimal: (field, [decimals = '*'] = []) => `Dit veld mag alleen numerieke, en${!decimals || decimals === '*' ? ' ' : decimals}decimale nummers bevatten.`,
        digits: (field, [length]) => `Dit veld moet ${length} nummers bevatten.`,
        dimensions: (field, [width, height]) => `De dimensies voor dit veld moet ${width} pixels breed en ${height} pixels hoog zijn.`,
        email: (field) => `This field must contain a valid e-mail address.`,
        ext: (field) => `This field must contain a correct file.`,
        image: (field) => `This field must contain an image.`,
        included: (field) => `This field must contain a valid value.`,
        integer: (field) => `This field must be a number.`,
        ip: (field) => `This field must be a secure IP address.`,
        length: (field, [length, max]) => {
            if (max) {
                return `Dit veld moet minimaal ${length} karakters en maximaal ${max} karakters bevatten.`;
            }

            return `Dit veld moet minimaal ${length} karakters lang zijn.`;
        },
        max: (field, [length]) => `This field can not contain more characters than ${length}.`,
        max_value: (field, [max]) => `Dit veld moet ${max} karakters of minder bevatten.`,
        mimes: (field) => `Dit veld moet Dit juiste type bestand bevatten.`,
        min: (field, [length]) => `Dit veld moet minimaal ${length} karakters zijn.`,
        min_value: (field, [min]) => `Dit veld moet minimaal ${min} karakters zijn.`,
        excluded: (field) => `Dit veld moet een geldige waarde bevatten`,
        numeric: (field) => `This field can only contain numerical characters.`,
        regex: (field) => `This field has not been entered correctly.`,
        required: (field) => `This field is required`,
        size: (field, [size]) => `The file size of this field can not be greater than ${formatFileSize(size)}.`,
        url: (field) => `This field must be a valid URL.`
    },
    CheckboxFocus: function() {
        // Specific code to auto blur (unfocus) in forms
        var checkboxes = document.querySelectorAll("input[type='checkbox']");
        checkboxes.forEach(function(item) {
            item.addEventListener("change", unFocus);
        });
    },
    Init: function () {
        Global.Blazy();
        Global.Barba();
        Global.Vvalidate();
        Global.CheckboxFocus();
    }
};

// ignore download links
Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

Barba.Pjax.preventCheck = function(evt, element) {
    if (!Barba.Pjax.originalPreventCheck(evt, element)) {
        return false;
    }

    // ignore pdf links
    if (/download.php/.test(element.href.toLowerCase())) {
        return false;
    }

    return true;
};

document.addEventListener("DOMContentLoaded", function () {
    Barba.Pjax.start();
    Global.CheckboxFocus();
});

Barba.Dispatcher.on("transitionCompleted", function () {
    Global.Init();
});

/**
 * Toevoeging voor het correct tracken in analytics
 *
 * @see https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications
 */
Barba.Dispatcher.on('newPageReady', function () {
    if (Barba.HistoryManager.history.length <= 1) {
        return;
    }

    // send statics by Google Analytics(analytics.js) or Google Tag Manager
    if (typeof ga === 'function' && typeof ga.getByName === 'function') {
        let tracker = ga.getByName('webnlPageview');
        if(typeof tracker !== 'undefined') {
            ga(tracker.get('name') + '.set', 'page', location.pathname);
            ga(tracker.get('name') + '.send', 'pageview');
        }
    }

    dataLayer.push({event: 'pageview'});
});

function unFocus() {
    this.blur();
};

function touchMenu() {
    // Specific code for iPad submenu's fix with touch
    if (this.classList.contains('hover')) {
        return true;
    } else {
        event.preventDefault();

        var menuItems = document.querySelectorAll(".header__listLink--with-sub-nav");
        menuItems.forEach(function(item) {
            item.classList.remove('hover');
            item.parentElement.classList.remove('hover');
        });
        this.classList.add('hover');
        this.parentElement.classList.add('hover');
    }
};
